import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API } from '../api';
import Layout from '../components/Layout';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  @keyframes fadeSlideIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
  @keyframes modalIn{from{opacity:0;transform:scale(0.94) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)}}
  @keyframes rowIn{from{opacity:0;transform:translateX(-10px)}to{opacity:1;transform:translateX(0)}}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}
  @keyframes pulse{0%,100%{box-shadow:0 0 0 0 rgba(99,179,237,0.4)}50%{box-shadow:0 0 0 8px rgba(99,179,237,0)}}
  *{box-sizing:border-box}
  .tp-root{font-family:'DM Sans',sans-serif;animation:fadeSlideIn 0.5s ease both}
  .tp-select{width:100%;padding:12px 16px;background:#f8faff;border:1.5px solid #e2e8f5;
    border-radius:12px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;cursor:pointer;appearance:none;
    background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%23a78bfa' stroke-width='2' fill='none'/%3E%3C/svg%3E");
    background-repeat:no-repeat;background-position:right 14px center;
    transition:border-color 0.2s,box-shadow 0.2s}
  .tp-select:focus{border-color:#a78bfa;box-shadow:0 0 0 3px rgba(167,139,250,0.15)}
  .tp-input{width:100%;padding:12px 16px;background:#f8faff;border:1.5px solid #e2e8f5;
    border-radius:12px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;transition:border-color 0.2s,box-shadow 0.2s,background 0.2s}
  .tp-input:focus{border-color:#a78bfa;background:#fff;box-shadow:0 0 0 3px rgba(167,139,250,0.15)}
  .tp-input::placeholder{color:#a0aec0}
  .tp-btn-primary{padding:12px 28px;background:linear-gradient(135deg,#a78bfa,#7c3aed);
    border:none;border-radius:12px;color:#fff;font-size:14px;font-weight:700;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:transform 0.15s,box-shadow 0.15s;
    display:inline-flex;align-items:center;gap:8px}
  .tp-btn-primary:hover{transform:translateY(-2px);box-shadow:0 8px 24px rgba(124,58,237,0.4)}
  .tp-btn-primary:disabled{opacity:0.6;cursor:not-allowed;transform:none}
  .tp-btn-secondary{padding:11px 22px;background:#f5f3ff;border:1.5px solid #ddd6fe;
    border-radius:12px;color:#6d28d9;font-size:14px;font-weight:600;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:all 0.15s}
  .tp-btn-secondary:hover{background:#ede9fe;border-color:#a78bfa;color:#5b21b6}
  .tp-row:hover td{background:#faf5ff !important;transition:background 0.15s}
  .action-btn{width:34px;height:34px;border:none;border-radius:9px;cursor:pointer;font-size:15px;
    display:inline-flex;align-items:center;justify-content:center;transition:transform 0.15s,box-shadow 0.15s}
  .action-btn:hover{transform:scale(1.18);box-shadow:0 4px 14px rgba(0,0,0,0.15)}
  .skeleton{background:linear-gradient(90deg,#f5f3ff 25%,#ede9fe 50%,#f5f3ff 75%);
    background-size:600px 100%;animation:shimmer 1.5s infinite;border-radius:6px}
  .nav-item{display:flex;align-items:center;gap:12px;padding-top:11px;padding-bottom:11px;
    padding-left:16px;padding-right:16px;cursor:pointer;border-radius:10px;margin:2px 10px;
    color:#aaa;font-size:14px;transition:all 0.15s;white-space:nowrap}
  .nav-item:hover{background:rgba(255,255,255,0.05);color:#fff}
  .nav-item.active{background:rgba(167,139,250,0.15);color:#a78bfa;border-left:3px solid #a78bfa;padding-left:13px}
  .tp-label{font-size:11px;font-weight:700;color:#718096;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:6px;display:block}
  .badge{padding:4px 12px;border-radius:20px;font-size:12px;font-weight:600;display:inline-block}
  .modal-scroll{overflow-y:auto;flex:1;padding:0 28px 20px}
  .modal-scroll::-webkit-scrollbar{width:5px}
  .modal-scroll::-webkit-scrollbar-thumb{background:#ddd6fe;border-radius:3px}
  .search-wrap input{padding:9px 14px 9px 38px;border:1.5px solid #e2e8f5;border-radius:20px;
    background:#fff;font-size:13px;outline:none;width:240px;transition:border-color 0.2s,width 0.3s;
    color:#1a1d2e;font-family:'DM Sans',sans-serif}
  .search-wrap input:focus{border-color:#a78bfa;box-shadow:0 0 0 3px rgba(167,139,250,0.12);width:300px}
`;

// const NAV = [
//   {icon:'⬡',  label:'Dashboard',        path:'/dashboard'},
//   {icon:'👥',  label:'User Management',  path:'/user-management'},
//   {icon:'⏱️',  label:'Rent Durations',   path:'/rent-durations'},
//   {icon:'💰',  label:'Car Price',        path:'/car-price'},
//   {icon:'🚕',  label:'Transfer Price',   path:'/transfer-price'},
//   {icon:'📋',  label:'Bookings',         path:'/bookings'},
//   {icon:'🚘',  label:'Vehicles',         path:'/vehicles'},
//   {icon:'👤',  label:'Customers',        path:'/customers'},
//   {icon:'💳',  label:'Payments',         path:'/payments'},
// ];

const EMPTY = { car_id:'', base_price:'', trnsfer_price:'' };

export default function TransferPrice() {
  const navigate = useNavigate();
  const location = useLocation();

  const [authUser,  setAuthUser]  = useState(null);
  const [sideOpen,  setSideOpen]  = useState(true);
  const [cars,      setCars]      = useState([]);
  const [prices,    setPrices]    = useState([]);
  const [loading,   setLoading]   = useState(true);
  const [form,      setForm]      = useState(EMPTY);
  const [editId,    setEditId]    = useState(null);
  const [saving,    setSaving]    = useState(false);
  const [viewModal, setViewModal] = useState(null);
  const [delModal,  setDelModal]  = useState(null);
  const [delSaving, setDelSaving] = useState(false);
  const [search,    setSearch]    = useState('');
  const [groupFilter, setGroupFilter] = useState('all');
  const [page,      setPage]      = useState(1);
  const [toast,     setToast]     = useState(null);
  const PER = 8;

  useEffect(() => {
    if (!localStorage.getItem('token')) { navigate('/login'); return; }
    setAuthUser(JSON.parse(localStorage.getItem('user') || '{}'));
    fetchAll();
  }, []);

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [c, p] = await Promise.all([
        API.get('/transfer-price/cars'),
        API.get('/transfer-price'),
      ]);
      setCars(c.data);
      setPrices(p.data);
    } catch(e) { showToast('Failed to load data', 'error'); }
    setLoading(false);
  };

  const showToast = (msg, type='success') => {
    setToast({msg, type});
    setTimeout(() => setToast(null), 3500);
  };

  const resetForm = useCallback(() => {
    setForm(EMPTY);
    setEditId(null);
  }, []);

  const startEdit = async (rec) => {
    setForm({
      car_id:       String(rec.car_id),
      base_price:   rec.base_price,
      trnsfer_price: rec.trnsfer_price,
    });
    setEditId(rec.transfer_id);
    window.scrollTo({top:0, behavior:'smooth'});
  };

  const handleSubmit = async () => {
    if (!form.car_id || !form.base_price || !form.trnsfer_price) {
      showToast('Car, Base Price and Price/KM are required', 'error'); return;
    }
    if (parseFloat(form.base_price) < 0 || parseFloat(form.trnsfer_price) < 0) {
      showToast('Prices must be positive values', 'error'); return;
    }
    setSaving(true);
    try {
      if (editId) {
        await API.put(`/transfer-price/${editId}`, form);
        showToast('Transfer price updated ✓');
      } else {
        await API.post('/transfer-price', form);
        showToast('Transfer price added ✓');
      }
      await fetchAll();
      resetForm();
    } catch(e) {
      showToast(e.response?.data?.message || 'Operation failed', 'error');
    }
    setSaving(false);
  };

  const handleDelete = async () => {
    setDelSaving(true);
    try {
      await API.delete(`/transfer-price/${delModal.transfer_id}`);
      showToast('Transfer price deleted ✓');
      setDelModal(null);
      await fetchAll();
      if (editId === delModal.transfer_id) resetForm();
    } catch(e) {
      showToast(e.response?.data?.message || 'Delete failed', 'error');
    }
    setDelSaving(false);
  };

  // Unique groups for filter pills
  const groups = [...new Map(cars.map(c => [c.group_id, c.group_name])).entries()]
    .map(([id, name]) => ({id, name}));

  const filtered = prices.filter(p => {
    const q = search.toLowerCase();
    const matchSearch = !search ||
      p.car_name?.toLowerCase().includes(q) ||
      p.group_name?.toLowerCase().includes(q);
    const matchGroup = groupFilter === 'all' || String(p.group_id) === String(groupFilter);
    return matchSearch && matchGroup;
  });

  const totalPages = Math.ceil(filtered.length / PER);
  const paged      = filtered.slice((page-1)*PER, page*PER);
  const logout     = () => { localStorage.clear(); navigate('/login'); };
  const f          = (k) => (e) => setForm(p => ({...p, [k]: e.target.value}));

  // Cars already having transfer price (for add form)
  const usedCarIds = prices.map(p => String(p.car_id));
  const availCars  = cars.filter(c => !usedCarIds.includes(String(c.car_id)) || String(c.car_id) === form.car_id);

  const getCarDetails = (carId) => cars.find(c => String(c.car_id) === String(carId));

  return (
    <Layout activePage="Season Duration">
    <>
      <style>{STYLES}</style>
      <div style={S.root} className="tp-root">

        {/* ── Sidebar ── */}
        {/* <aside style={{...S.sidebar, width: sideOpen ? 220 : 68}}>
          <div style={S.sideTop}>
            <div style={S.logoWrap}>
              <div style={S.logoIcon}>🚗</div>
              {sideOpen && <span style={S.logoText}>Orisys</span>}
            </div>
            <button style={S.collapseBtn} onClick={() => setSideOpen(p => !p)}>
              {sideOpen ? '◀' : '▶'}
            </button>
          </div>
          <nav style={{flex:1}}>
            {NAV.map(n => (
              <div key={n.label}
                className={`nav-item${location.pathname === n.path ? ' active' : ''}`}
                onClick={() => navigate(n.path)}>
                <span style={{fontSize:16, flexShrink:0}}>{n.icon}</span>
                {sideOpen && <span style={{fontWeight:500}}>{n.label}</span>}
              </div>
            ))}
          </nav>
          <div style={S.sideBottom}>
            {sideOpen && (
              <div style={S.userChip}>
                <div style={S.avatar}>{authUser?.user_name?.[0] || 'A'}</div>
                <div>
                  <div style={S.uname}>{authUser?.user_name || 'Admin'}</div>
                  <div style={S.urole}>Administrator</div>
                </div>
              </div>
            )}
            <button style={S.logoutBtn} onClick={logout}>
              <span>🚪</span>{sideOpen && <span style={{marginLeft:8}}>Logout</span>}
            </button>
          </div>
        </aside> */}

        {/* ── Main ── */}
        <main >

          {/* Header */}
          <div style={S.pageHeader}>
            <div>
              <h1 style={S.pageTitle}>Transfer Price</h1>
              <p style={S.pageSub}>Set base price and per-KM rate for car transfers</p>
            </div>
            <div style={{display:'flex', gap:12}}>
              {[
                {label:'Total Entries', value:prices.length,      color:'#7c3aed', bg:'#f5f3ff', icon:'🚕'},
                {label:'Cars Covered',  value:prices.length,      color:'#db2777', bg:'#fdf2f8', icon:'🚘'},
                {label:'Car Groups',    value:groups.length,      color:'#0891b2', bg:'#ecfeff', icon:'🗂️'},
              ].map(s => (
                <div key={s.label} style={{...S.miniStat, background:s.bg}}>
                  <span style={{fontSize:22}}>{s.icon}</span>
                  <div>
                    <div style={{fontSize:22, fontWeight:800, color:s.color, lineHeight:1}}>{s.value}</div>
                    <div style={{fontSize:10, color:'#718096', fontWeight:600, textTransform:'uppercase'}}>{s.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Add / Edit Form ── */}
          <div style={S.formCard}>
            {/* Card header */}
            <div style={S.formCardHead}>
              <div style={S.formCardIcon}>{editId ? '✏️' : '🚕'}</div>
              <div style={{flex:1}}>
                <h2 style={S.formCardTitle}>
                  {editId ? 'Edit Transfer Price' : 'Add Transfer Price'}
                </h2>
                <p style={S.formCardSub}>
                  {editId
                    ? `Editing: ${prices.find(p => p.transfer_id === editId)?.car_name}`
                    : 'Set base fare and per-kilometre rate for a car'}
                </p>
              </div>
              {editId && (
                <button className="tp-btn-secondary" onClick={resetForm}>✕ Cancel</button>
              )}
            </div>

            {/* Form fields */}
            <div style={S.formGrid}>
              {/* Car select */}
              <div style={{gridColumn:'1/-1'}}>
                <label className="tp-label">Select Car *</label>
                <select className="tp-select" value={form.car_id} onChange={f('car_id')}>
                  <option value="">— Select Car —</option>
                  {/* Group cars by group */}
                  {groups.map(g => (
                    <optgroup key={g.id} label={g.name}>
                      {availCars
                        .filter(c => String(c.group_id) === String(g.id))
                        .map(c => (
                          <option key={c.car_id} value={c.car_id}>{c.car_name}</option>
                        ))}
                    </optgroup>
                  ))}
                </select>
                {form.car_id && (
                  <div style={{marginTop:8,display:'flex',alignItems:'center',gap:8}}>
                    <div style={{width:8,height:8,borderRadius:'50%',background:'#a78bfa'}}/>
                    <span style={{fontSize:12,color:'#6d28d9',fontWeight:600}}>
                      Group: {getCarDetails(form.car_id)?.group_name || '—'}
                    </span>
                  </div>
                )}
              </div>

              {/* Base Price */}
              <div>
                <label className="tp-label">Base Price (₹) *</label>
                <div style={{position:'relative'}}>
                  <span style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',
                    color:'#a78bfa',fontWeight:800,fontSize:16}}>₹</span>
                  <input className="tp-input" type="number" min="0" step="0.01"
                    placeholder="0.00" value={form.base_price} onChange={f('base_price')}
                    style={{paddingLeft:34}}/>
                </div>
                <div style={{fontSize:11,color:'#a0aec0',marginTop:4}}>
                  Flat base charge for the transfer
                </div>
              </div>

              {/* Price per KM */}
              <div>
                <label className="tp-label">Price / KM (₹) *</label>
                <div style={{position:'relative'}}>
                  <span style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',
                    color:'#db2777',fontWeight:800,fontSize:14}}>₹/km</span>
                  <input className="tp-input" type="number" min="0" step="0.01"
                    placeholder="0.00" value={form.trnsfer_price} onChange={f('trnsfer_price')}
                    style={{paddingLeft:52}}/>
                </div>
                <div style={{fontSize:11,color:'#a0aec0',marginTop:4}}>
                  Charged per kilometre of distance
                </div>
              </div>
            </div>

            {/* Live preview */}
            {form.base_price && form.trnsfer_price && (
              <div style={S.previewBox}>
                <div style={{fontSize:13,color:'#6d28d9',fontWeight:700,marginBottom:8}}>
                  📊 Live Fare Preview
                </div>
                <div style={{display:'flex',gap:16,flexWrap:'wrap'}}>
                  {[10, 20, 50, 100].map(km => {
                    const fare = parseFloat(form.base_price) + parseFloat(form.trnsfer_price) * km;
                    return (
                      <div key={km} style={{background:'#fff',borderRadius:10,padding:'10px 16px',
                        border:'1.5px solid #ddd6fe',textAlign:'center',minWidth:90}}>
                        <div style={{fontSize:11,color:'#a0aec0',fontWeight:600}}>{km} KM</div>
                        <div style={{fontSize:17,fontWeight:800,color:'#7c3aed',marginTop:2}}>
                          ₹{fare.toFixed(0)}
                        </div>
                      </div>
                    );
                  })}
                </div>
                <div style={{fontSize:11,color:'#a0aec0',marginTop:10}}>
                  Formula: Base ₹{form.base_price} + (₹{form.trnsfer_price} × km)
                </div>
              </div>
            )}

            {/* Submit */}
            <div style={{display:'flex',gap:12,marginTop:20,justifyContent:'flex-end'}}>
              {editId && (
                <button className="tp-btn-secondary" onClick={resetForm}>Cancel</button>
              )}
              <button className="tp-btn-primary" onClick={handleSubmit} disabled={saving}>
                {saving
                  ? <span style={S.spinner}/>
                  : editId ? '💾 Update Price' : '＋ Add Transfer Price'}
              </button>
            </div>
          </div>

          {/* ── Manage Table ── */}
          <div style={S.tableCard}>
            <div style={S.tableCardHead}>
              <h3 style={S.tableCardTitle}>📋 Manage Transfer Prices</h3>
              <div style={{display:'flex',gap:10,alignItems:'center',flexWrap:'wrap'}}>
                {/* Group filter pills */}
                <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                  {[{id:'all',name:'All'}, ...groups].map(g => (
                    <button key={g.id}
                      onClick={() => {setGroupFilter(String(g.id));setPage(1);}}
                      style={{padding:'5px 12px',borderRadius:20,border:'1.5px solid',
                        fontSize:12,fontWeight:600,cursor:'pointer',fontFamily:'DM Sans,sans-serif',
                        transition:'all 0.15s',
                        background:groupFilter===String(g.id)?'#a78bfa':'#fff',
                        borderColor:groupFilter===String(g.id)?'#a78bfa':'#e2e8f5',
                        color:groupFilter===String(g.id)?'#fff':'#718096'}}>
                      {g.name}
                    </button>
                  ))}
                </div>
                {/* Search */}
                <div className="search-wrap" style={{position:'relative'}}>
                  <span style={{position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',
                    color:'#a0aec0',fontSize:14,pointerEvents:'none'}}>🔍</span>
                  <input placeholder="Search car or group…"
                    value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}}/>
                </div>
                <span style={{fontSize:12,background:'#f5f3ff',color:'#7c3aed',
                  borderRadius:20,padding:'4px 14px',fontWeight:700,whiteSpace:'nowrap'}}>
                  {filtered.length} records
                </span>
              </div>
            </div>

            <div style={{overflowX:'auto'}}>
              <table style={S.table}>
                <thead>
                  <tr style={{background:'linear-gradient(135deg,#f5f3ff,#ede9fe)'}}>
                    {['#','Car','Group','Base Price','Price / KM','Total (50 KM est.)','Actions'].map(h=>(
                      <th key={h} style={S.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading
                    ? Array.from({length:5}).map((_,i) => (
                        <tr key={i}>
                          {Array.from({length:7}).map((_,j) => (
                            <td key={j} style={S.td}>
                              <div className="skeleton" style={{height:14, width:'70%'}}/>
                            </td>
                          ))}
                        </tr>
                      ))
                    : paged.length === 0
                    ? (
                        <tr>
                          <td colSpan={7} style={{textAlign:'center',padding:'48px 0',color:'#a0aec0'}}>
                            <div style={{fontSize:40,marginBottom:10}}>🚕</div>
                            <div style={{fontSize:15,fontWeight:600}}>No transfer prices added yet</div>
                            <div style={{fontSize:13,marginTop:4}}>Use the form above to add your first entry</div>
                          </td>
                        </tr>
                      )
                    : paged.map((p, i) => {
                        const est50 = (parseFloat(p.base_price) + parseFloat(p.trnsfer_price) * 50).toFixed(0);
                        return (
                          <tr key={p.transfer_id} className="tp-row"
                            style={{borderBottom:'1px solid #f0f4ff',
                              background:editId===p.transfer_id?'#faf5ff':i%2===0?'#fff':'#fafbff'}}>
                            <td style={{...S.td,color:'#a0aec0',fontWeight:700,fontSize:12}}>
                              {(page-1)*PER+i+1}
                            </td>
                            <td style={S.td}>
                              <div style={{display:'flex',alignItems:'center',gap:10}}>
                                <div style={{width:36,height:36,borderRadius:10,flexShrink:0,
                                  background:'linear-gradient(135deg,#a78bfa,#7c3aed)',
                                  display:'flex',alignItems:'center',justifyContent:'center',
                                  color:'#fff',fontSize:16}}>
                                  🚕
                                </div>
                                <div>
                                  <div style={{fontWeight:700,fontSize:14,color:'#1a1d2e'}}>{p.car_name}</div>
                                  {editId === p.transfer_id && (
                                    <span style={{fontSize:10,background:'#fef9c3',color:'#854d0e',
                                      padding:'1px 6px',borderRadius:10,fontWeight:700}}>EDITING</span>
                                  )}
                                </div>
                              </div>
                            </td>
                            <td style={S.td}>
                              <span className="badge" style={{background:'#f0fdf4',color:'#166534'}}>
                                🗂️ {p.group_name}
                              </span>
                            </td>
                            <td style={S.td}>
                              <div style={{fontWeight:800,fontSize:16,color:'#7c3aed'}}>
                                ₹{parseFloat(p.base_price).toLocaleString()}
                              </div>
                              <div style={{fontSize:11,color:'#a0aec0'}}>flat base</div>
                            </td>
                            <td style={S.td}>
                              <div style={{fontWeight:800,fontSize:16,color:'#db2777'}}>
                                ₹{parseFloat(p.trnsfer_price).toLocaleString()}
                              </div>
                              <div style={{fontSize:11,color:'#a0aec0'}}>per km</div>
                            </td>
                            <td style={S.td}>
                              <span className="badge" style={{background:'#f5f3ff',color:'#6d28d9',fontSize:13}}>
                                ₹{parseInt(est50).toLocaleString()}
                              </span>
                            </td>
                            <td style={S.td}>
                              <div style={{display:'flex',gap:6}}>
                                <button className="action-btn"
                                  style={{background:'#f0e9ff',color:'#7c3aed'}}
                                  title="View" onClick={()=>setViewModal(p)}>👁</button>
                                <button className="action-btn"
                                  style={{background:'#fefcbf',color:'#744210'}}
                                  title="Edit" onClick={()=>startEdit(p)}>✏️</button>
                                <button className="action-btn"
                                  style={{background:'#fff5f5',color:'#c53030'}}
                                  title="Delete" onClick={()=>setDelModal(p)}>🗑</button>
                              </div>
                            </td>
                          </tr>
                        );
                      })
                  }
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={S.pagination}>
                <span style={{fontSize:13,color:'#718096'}}>
                  Showing {(page-1)*PER+1}–{Math.min(page*PER,filtered.length)} of {filtered.length}
                </span>
                <div style={{display:'flex',gap:6}}>
                  <button style={S.pageBtn} disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</button>
                  {Array.from({length:totalPages},(_,i)=>i+1).map(p=>(
                    <button key={p} style={{...S.pageBtn,...(p===page?S.pageBtnActive:{})}}
                      onClick={()=>setPage(p)}>{p}</button>
                  ))}
                  <button style={S.pageBtn} disabled={page===totalPages} onClick={()=>setPage(p=>p+1)}>Next →</button>
                </div>
              </div>
            )}
          </div>
        </main>

        {/* ── View Modal ── */}
        {viewModal && (
          <div style={S.overlay} onClick={()=>setViewModal(null)}>
            <div style={{...S.modal,maxWidth:480}} onClick={e=>e.stopPropagation()}>
              <div style={S.modalHead}>
                <div>
                  <h2 style={S.modalTitle}>🚕 Transfer Price Details</h2>
                  <p style={S.modalSub}>{viewModal.car_name}</p>
                </div>
                <button style={S.xBtn} onClick={()=>setViewModal(null)}>✕</button>
              </div>
              <div className="modal-scroll" style={{padding:'20px 28px'}}>
                {/* Car info */}
                <div style={{display:'flex',alignItems:'center',gap:16,padding:'16px',
                  background:'linear-gradient(135deg,#f5f3ff,#ede9fe)',
                  borderRadius:16,marginBottom:20,border:'1.5px solid #ddd6fe'}}>
                  <div style={{width:56,height:56,borderRadius:16,
                    background:'linear-gradient(135deg,#a78bfa,#7c3aed)',
                    display:'flex',alignItems:'center',justifyContent:'center',fontSize:26}}>
                    🚕
                  </div>
                  <div>
                    <div style={{fontSize:18,fontWeight:800,color:'#1a1d2e'}}>{viewModal.car_name}</div>
                    <span className="badge" style={{background:'#f0fdf4',color:'#166534',marginTop:4}}>
                      🗂️ {viewModal.group_name}
                    </span>
                  </div>
                </div>

                {/* Pricing info */}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:20}}>
                  <div style={{background:'#faf5ff',borderRadius:14,padding:'16px 18px',
                    border:'1.5px solid #ddd6fe',textAlign:'center'}}>
                    <div style={{fontSize:11,color:'#6d28d9',fontWeight:700,textTransform:'uppercase',
                      letterSpacing:'0.5px',marginBottom:6}}>Base Price</div>
                    <div style={{fontSize:28,fontWeight:800,color:'#7c3aed'}}>
                      ₹{parseFloat(viewModal.base_price).toLocaleString()}
                    </div>
                    <div style={{fontSize:11,color:'#a0aec0',marginTop:4}}>flat fare</div>
                  </div>
                  <div style={{background:'#fdf2f8',borderRadius:14,padding:'16px 18px',
                    border:'1.5px solid #fbcfe8',textAlign:'center'}}>
                    <div style={{fontSize:11,color:'#9d174d',fontWeight:700,textTransform:'uppercase',
                      letterSpacing:'0.5px',marginBottom:6}}>Per KM Rate</div>
                    <div style={{fontSize:28,fontWeight:800,color:'#db2777'}}>
                      ₹{parseFloat(viewModal.trnsfer_price).toLocaleString()}
                    </div>
                    <div style={{fontSize:11,color:'#a0aec0',marginTop:4}}>per kilometre</div>
                  </div>
                </div>

                {/* Fare table */}
                <div style={{marginBottom:8,fontSize:12,fontWeight:700,color:'#718096',
                  textTransform:'uppercase',letterSpacing:'0.5px'}}>
                  Estimated Fares
                </div>
                <div style={{borderRadius:12,overflow:'hidden',border:'1.5px solid #ede9fe'}}>
                  <table style={{width:'100%',borderCollapse:'collapse'}}>
                    <thead>
                      <tr style={{background:'linear-gradient(135deg,#a78bfa,#7c3aed)'}}>
                        <th style={{padding:'10px 16px',color:'#fff',fontSize:12,fontWeight:700,textAlign:'left'}}>Distance</th>
                        <th style={{padding:'10px 16px',color:'#fff',fontSize:12,fontWeight:700,textAlign:'left'}}>Estimated Fare</th>
                        <th style={{padding:'10px 16px',color:'#fff',fontSize:12,fontWeight:700,textAlign:'left'}}>Breakdown</th>
                      </tr>
                    </thead>
                    <tbody>
                      {[5,10,20,30,50,100].map((km,i)=>{
                        const base = parseFloat(viewModal.base_price);
                        const perKm = parseFloat(viewModal.trnsfer_price);
                        const fare = base + perKm * km;
                        return (
                          <tr key={km} style={{borderBottom:'1px solid #f5f3ff',
                            background:i%2===0?'#fff':'#faf5ff'}}>
                            <td style={{padding:'10px 16px',fontSize:13,fontWeight:600,color:'#4a5568'}}>
                              {km} km
                            </td>
                            <td style={{padding:'10px 16px',fontSize:14,fontWeight:800,color:'#7c3aed'}}>
                              ₹{fare.toFixed(0)}
                            </td>
                            <td style={{padding:'10px 16px',fontSize:11,color:'#a0aec0'}}>
                              ₹{base} + (₹{perKm} × {km})
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
              <div style={S.modalFoot}>
                <button className="tp-btn-secondary" onClick={()=>setViewModal(null)}>Close</button>
                <button className="tp-btn-primary"
                  onClick={()=>{setViewModal(null);setTimeout(()=>startEdit(viewModal),100);}}>
                  ✏️ Edit Price
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Delete Modal ── */}
        {delModal && (
          <div style={S.overlay} onClick={()=>setDelModal(null)}>
            <div style={{...S.modal,maxWidth:420}} onClick={e=>e.stopPropagation()}>
              <div style={{padding:'36px 32px',textAlign:'center'}}>
                <div style={{fontSize:52,marginBottom:16}}>🗑️</div>
                <h2 style={{fontSize:20,fontWeight:800,color:'#1a1d2e',marginBottom:8}}>Delete Transfer Price?</h2>
                <div style={{marginBottom:16,display:'flex',gap:8,justifyContent:'center',flexWrap:'wrap'}}>
                  <span className="badge" style={{background:'#f5f3ff',color:'#7c3aed'}}>
                    🚕 {delModal.car_name}
                  </span>
                  <span className="badge" style={{background:'#fdf2f8',color:'#db2777'}}>
                    ₹{delModal.base_price} base
                  </span>
                  <span className="badge" style={{background:'#f0fdf4',color:'#166534'}}>
                    ₹{delModal.trnsfer_price}/km
                  </span>
                </div>
                <p style={{color:'#718096',fontSize:14,lineHeight:1.7,marginBottom:28}}>
                  Are you sure you want to delete this transfer price?<br/>
                  <strong style={{color:'#e53e3e'}}>This action cannot be undone.</strong>
                </p>
                <div style={{display:'flex',gap:12,justifyContent:'center'}}>
                  <button className="tp-btn-secondary" onClick={()=>setDelModal(null)}>Cancel</button>
                  <button disabled={delSaving} onClick={handleDelete} style={{
                    padding:'12px 24px',background:'linear-gradient(135deg,#fc8181,#e53e3e)',
                    border:'none',borderRadius:12,color:'#fff',fontWeight:700,fontSize:14,
                    fontFamily:'DM Sans,sans-serif',cursor:'pointer',
                    display:'flex',alignItems:'center',gap:8}}>
                    {delSaving ? <span style={S.spinner}/> : '🗑️ Delete Permanently'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Toast ── */}
        {toast && (
          <div style={{...S.toast,
            background:toast.type==='error'?'#fff5f5':'#f5f3ff',
            borderColor:toast.type==='error'?'#fc8181':'#a78bfa',
            color:toast.type==='error'?'#c53030':'#6d28d9'}}>
            {toast.type==='error'?'⚠️':'✅'} {toast.msg}
          </div>
        )}
      </div>
    </>
    </Layout>
  );
}

/* ─── Styles ─── */
const S = {
  root:{display:'flex',minHeight:'100vh',background:'#faf8ff'},
  sidebar:{background:'#1a1d2e',color:'#fff',display:'flex',flexDirection:'column',
    position:'fixed',height:'100vh',transition:'width 0.25s',overflow:'hidden',zIndex:100},
  sideTop:{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'20px 16px 16px'},
  logoWrap:{display:'flex',alignItems:'center',gap:10},
  logoIcon:{width:36,height:36,background:'linear-gradient(135deg,#a78bfa,#7c3aed)',borderRadius:10,
    display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,flexShrink:0},
  logoText:{fontSize:18,fontWeight:800,letterSpacing:'-0.5px',whiteSpace:'nowrap',fontFamily:"'Syne',sans-serif"},
  collapseBtn:{background:'rgba(255,255,255,0.08)',border:'none',color:'#aaa',borderRadius:6,
    padding:'4px 8px',cursor:'pointer',fontSize:11,flexShrink:0},
  sideBottom:{padding:'16px',borderTop:'1px solid rgba(255,255,255,0.07)'},
  userChip:{display:'flex',alignItems:'center',gap:10,marginBottom:12},
  avatar:{width:36,height:36,background:'linear-gradient(135deg,#a78bfa,#7c3aed)',borderRadius:'50%',
    display:'flex',alignItems:'center',justifyContent:'center',fontWeight:800,fontSize:15,flexShrink:0},
  uname:{fontSize:13,fontWeight:700,color:'#fff'},
  urole:{fontSize:11,color:'#777'},
  logoutBtn:{width:'100%',background:'rgba(167,139,250,0.12)',border:'1px solid rgba(167,139,250,0.25)',
    color:'#a78bfa',borderRadius:8,padding:'8px 12px',cursor:'pointer',fontSize:13,
    display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'inherit'},

  main:{flex:1,padding:'28px',minWidth:0},
  pageHeader:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',
    marginBottom:24,flexWrap:'wrap',gap:16},
  pageTitle:{fontSize:26,fontWeight:800,color:'#1a1d2e',letterSpacing:'-0.5px',margin:0,
    fontFamily:"'Syne',sans-serif"},
  pageSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  miniStat:{display:'flex',alignItems:'center',gap:12,borderRadius:14,padding:'14px 18px',
    boxShadow:'0 2px 10px rgba(0,0,0,0.05)'},

  formCard:{background:'#fff',borderRadius:20,padding:'28px',
    boxShadow:'0 4px 24px rgba(124,58,237,0.08)',marginBottom:24,
    border:'1.5px solid #ede9fe'},
  formCardHead:{display:'flex',alignItems:'flex-start',gap:16,marginBottom:22},
  formCardIcon:{width:48,height:48,background:'linear-gradient(135deg,#a78bfa,#7c3aed)',
    borderRadius:14,display:'flex',alignItems:'center',justifyContent:'center',
    fontSize:22,flexShrink:0,boxShadow:'0 4px 14px rgba(124,58,237,0.3)'},
  formCardTitle:{fontSize:18,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  formCardSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  formGrid:{display:'grid',gridTemplateColumns:'1fr 1fr',gap:16},

  previewBox:{marginTop:20,background:'linear-gradient(135deg,#f5f3ff,#ede9fe)',
    borderRadius:14,padding:'18px 20px',border:'1.5px solid #ddd6fe'},

  tableCard:{background:'#fff',borderRadius:20,overflow:'hidden',
    boxShadow:'0 4px 24px rgba(124,58,237,0.08)',marginBottom:20,border:'1.5px solid #ede9fe'},
  tableCardHead:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'20px 24px',borderBottom:'1px solid #f5f3ff',flexWrap:'wrap',gap:12},
  tableCardTitle:{fontSize:16,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  table:{width:'100%',borderCollapse:'collapse'},
  th:{padding:'14px 20px',fontSize:11,fontWeight:700,color:'#718096',textAlign:'left',
    textTransform:'uppercase',letterSpacing:'0.5px',borderBottom:'2px solid #ede9fe'},
  td:{padding:'14px 20px',fontSize:13,color:'#4a5568',verticalAlign:'middle'},

  pagination:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'16px 24px',borderTop:'1px solid #f5f3ff'},
  pageBtn:{padding:'6px 12px',border:'1.5px solid #e2e8f5',borderRadius:8,background:'#fff',
    color:'#718096',fontSize:13,fontWeight:600,cursor:'pointer',
    fontFamily:'DM Sans,sans-serif',transition:'all 0.15s'},
  pageBtnActive:{background:'#a78bfa',borderColor:'#a78bfa',color:'#fff'},

  overlay:{position:'fixed',inset:0,background:'rgba(10,5,40,0.6)',zIndex:200,
    display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(4px)',padding:'20px'},
  modal:{background:'#fff',borderRadius:20,width:'100%',maxWidth:620,maxHeight:'90vh',
    display:'flex',flexDirection:'column',
    boxShadow:'0 32px 80px rgba(124,58,237,0.25)',animation:'modalIn 0.3s ease both'},
  modalHead:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',
    padding:'24px 28px 0',flexShrink:0},
  modalTitle:{fontSize:20,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  modalSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  modalFoot:{display:'flex',gap:12,justifyContent:'flex-end',
    padding:'16px 28px',borderTop:'1px solid #f5f3ff',flexShrink:0},
  xBtn:{background:'rgba(167,139,250,0.15)',border:'none',color:'#7c3aed',borderRadius:'50%',
    width:32,height:32,cursor:'pointer',fontWeight:800,fontSize:14,
    display:'flex',alignItems:'center',justifyContent:'center'},

  spinner:{display:'inline-block',width:16,height:16,border:'2px solid rgba(255,255,255,0.3)',
    borderTopColor:'#fff',borderRadius:'50%',animation:'spin 0.6s linear infinite'},
  toast:{position:'fixed',bottom:28,right:28,zIndex:999,padding:'14px 22px',
    borderRadius:12,border:'1.5px solid',fontSize:14,fontWeight:600,
    fontFamily:'DM Sans,sans-serif',boxShadow:'0 8px 24px rgba(0,0,0,0.12)',
    animation:'fadeSlideIn 0.3s ease'},
};